module.exports = __webpack_public_path__ + "static/media/logo_credelesc.03b36068.svg";